import React, { useState } from 'react';

function PublicLayout({ children, onLogin, onRegister }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div style={{ minHeight: '100vh' }}>
      {/* Navigation Bar */}
      <nav style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: 'rgba(10, 14, 39, 0.95)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid var(--border-color)',
        boxShadow: '0 4px 30px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '15px 20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          {/* Logo */}
          <div className="logo" style={{ cursor: 'pointer', fontSize: '1.8rem' }}>
            <span className="zero">ZERO</span>
            <span className="ping">PING</span>
          </div>

          {/* Desktop Navigation */}
          <div style={{
            display: 'flex',
            gap: '30px',
            alignItems: 'center'
          }} className="desktop-nav">
            <a href="/" style={{
              color: 'var(--text-primary)',
              textDecoration: 'none',
              fontSize: '1.1rem',
              fontWeight: '600',
              transition: 'color 0.3s',
              cursor: 'pointer'
            }}
              onMouseEnter={(e) => e.target.style.color = 'var(--primary-color)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-primary)'}
            >
              Home
            </a>
            <a href="/#matches" style={{
              color: 'var(--text-primary)',
              textDecoration: 'none',
              fontSize: '1.1rem',
              fontWeight: '600',
              transition: 'color 0.3s',
              cursor: 'pointer'
            }}
              onMouseEnter={(e) => e.target.style.color = 'var(--primary-color)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-primary)'}
            >
              Matches
            </a>
            <a href="/#results" style={{
              color: 'var(--text-primary)',
              textDecoration: 'none',
              fontSize: '1.1rem',
              fontWeight: '600',
              transition: 'color 0.3s',
              cursor: 'pointer'
            }}
              onMouseEnter={(e) => e.target.style.color = 'var(--primary-color)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-primary)'}
            >
              Results
            </a>
            <a href="/#about" style={{
              color: 'var(--text-primary)',
              textDecoration: 'none',
              fontSize: '1.1rem',
              fontWeight: '600',
              transition: 'color 0.3s',
              cursor: 'pointer'
            }}
              onMouseEnter={(e) => e.target.style.color = 'var(--primary-color)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-primary)'}
            >
              About
            </a>
          </div>

          {/* Auth Buttons */}
          <div style={{
            display: 'flex',
            gap: '15px',
            alignItems: 'center'
          }} className="desktop-nav">
            <button
              className="btn btn-outline"
              onClick={onLogin}
              style={{ padding: '8px 24px' }}
            >
              Login
            </button>
            <button
              className="btn btn-primary"
              onClick={onRegister}
              style={{ padding: '8px 24px' }}
            >
              Sign Up
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{
              display: 'none',
              background: 'transparent',
              border: 'none',
              color: 'var(--primary-color)',
              fontSize: '1.8rem',
              cursor: 'pointer'
            }}
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="mobile-menu" style={{
            display: 'none',
            flexDirection: 'column',
            gap: '15px',
            padding: '20px',
            background: 'var(--secondary-bg)',
            borderTop: '1px solid var(--border-color)'
          }}>
            <a href="/" style={{ color: 'var(--text-primary)', textDecoration: 'none', fontSize: '1.1rem' }}>
              Home
            </a>
            <a href="/#matches" style={{ color: 'var(--text-primary)', textDecoration: 'none', fontSize: '1.1rem' }}>
              Matches
            </a>
            <a href="/#results" style={{ color: 'var(--text-primary)', textDecoration: 'none', fontSize: '1.1rem' }}>
              Results
            </a>
            <a href="/#about" style={{ color: 'var(--text-primary)', textDecoration: 'none', fontSize: '1.1rem' }}>
              About
            </a>
            <button className="btn btn-outline" onClick={onLogin} style={{ width: '100%' }}>
              Login
            </button>
            <button className="btn btn-primary" onClick={onRegister} style={{ width: '100%' }}>
              Sign Up
            </button>
          </div>
        )}
      </nav>

      {/* Content */}
      <div>
        {children}

        {/* Floating WhatsApp Icon */}
        <a
          href="https://chat.whatsapp.com/B6fBHPfIpmUGmWXO3u8pqt"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 1000,
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            background: '#25D366',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.3s',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.1)';
            e.currentTarget.style.boxShadow = '0 6px 14px rgba(0, 0, 0, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.3)';
          }}
        >
          <img
            src="/WhatsApp_Logo_green.svg.webp"
            alt="Join WhatsApp Group"
            style={{
              width: '35px',
              height: '35px',
              objectFit: 'contain',
              filter: 'brightness(0) invert(1)'
            }}
          />
        </a>
      </div>

      {/* Footer */}
      <footer style={{
        background: 'var(--secondary-bg)',
        borderTop: '1px solid var(--border-color)',
        padding: '60px 20px 30px',
        marginTop: '80px'
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '40px',
            marginBottom: '40px'
          }}>
            {/* Brand */}
            <div>
              <div className="logo" style={{ marginBottom: '20px', fontSize: '1.5rem' }}>
                <span className="zero">ZERO</span>
                <span className="ping">PING</span>
              </div>
              <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                India's premier BGMI tournament platform. Compete, win, and get paid instantly!
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h3 style={{ fontSize: '1.2rem', marginBottom: '20px', color: 'var(--primary-color)' }}>
                Quick Links
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <a href="/" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Home</a>
                <a href="/#matches" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Matches</a>
                <a href="/#results" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Results</a>
                <a href="/#about" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>About Us</a>
              </div>
            </div>

            {/* Support */}
            <div>
              <h3 style={{ fontSize: '1.2rem', marginBottom: '20px', color: 'var(--primary-color)' }}>
                Support
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <a href="/disclaimer" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Disclaimer</a>
                <a href="/privacy-policy" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Privacy Policy</a>
                <a href="mailto:support@zeroping.app" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                  support@zeroping.app
                </a>
              </div>
            </div>

            {/* Social */}
            <div>
              <h3 style={{ fontSize: '1.2rem', marginBottom: '20px', color: 'var(--primary-color)' }}>
                Connect With Us
              </h3>
              <div style={{ display: 'flex', gap: '15px' }}>
                {/* YouTube */}
                <a href="https://youtube.com/@TheZeroPing" target="_blank" rel="noopener noreferrer" style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: 'rgba(255, 255, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s'
                }}>
                  <img src="/YouTube_social_white_square_(2024).svg.png" alt="YouTube" style={{ width: '24px', height: '24px', objectFit: 'contain' }} />
                </a>

                {/* Instagram */}
                <a href="https://instagram.com/zeroping.app" target="_blank" rel="noopener noreferrer" style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: 'rgba(255, 255, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s'
                }}>
                  <img src="/Instagram_logo_2022.svg.webp" alt="Instagram" style={{ width: '24px', height: '24px', objectFit: 'contain' }} />
                </a>

                {/* Telegram */}
                <a href="#" style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: 'rgba(255, 255, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s'
                }}>
                  <img src="/Telegram_2019_Logo.svg.webp" alt="Telegram" style={{ width: '24px', height: '24px', objectFit: 'contain' }} />
                </a>

                {/* WhatsApp */}
                <a href="https://chat.whatsapp.com/F04COPemmeB70tPvvp6YOV" target="_blank" rel="noopener noreferrer" style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: 'rgba(255, 255, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s'
                }}>
                  <img src="/WhatsApp_Logo_green.svg.webp" alt="WhatsApp" style={{ width: '24px', height: '24px', objectFit: 'contain' }} />
                </a>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div style={{
            paddingTop: '30px',
            borderTop: '1px solid var(--border-color)',
            textAlign: 'center',
            color: 'var(--text-secondary)',
            fontSize: '0.9rem'
          }}>
            <p>© 2024 ZeroPing. All rights reserved. Built with ❤️ for the gaming community.</p>
            <p style={{ marginTop: '10px' }}>
              <a
                href="/admin/login"
                style={{
                  color: 'var(--text-secondary)',
                  textDecoration: 'none',
                  fontSize: '0.8rem',
                  opacity: 0.5,
                  transition: 'opacity 0.3s'
                }}
                onMouseEnter={(e) => e.target.style.opacity = '1'}
                onMouseLeave={(e) => e.target.style.opacity = '0.5'}
              >
                Admin Access
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PublicLayout;
